import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

/**
 * @tags styled, ribbon, label
 */
const Ribbon = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  position: absolute;
  top: 10px;
  padding: 2px 10px 2px 10px;
  font-size: 13px;
  
  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -4px;
    border: 4px solid;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
  }
  
  ${({
    theme,
    side, type
  }) => css`
    ${side}: -7px;
    padding-${side}: 15px;
    text-align: ${side === 'left' ? 'right' : 'left'};
    background-color: ${type === 'default' ? '#e3e3e3' : theme.colors.primary.hover};
    color: ${type === 'default' ? theme.colors.shades[2] : theme.colors.shades[7]};
    
    &:before {
      transform: rotate(${side === 'right' && '-'}45deg);
      ${side}: 2px;
      border-bottom-color: ${type === 'default' ? '#b8b8b8' : '#090c3e'};
    }
  `};
`;

Ribbon.propTypes = {
  children: PropTypes.node.isRequired,
  side: PropTypes.oneOf(['left', 'right']),
  type: PropTypes.oneOf(['default', 'info']),
  qa: PropTypes.string
};

Ribbon.defaultProps = {
  side: 'left',
  type: 'default',
  qa: undefined
};

/** @component */
export default Ribbon;
